import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "nativewind/jsx-runtime";
import React, { useState } from 'react';
import styled from 'styled-components/native';
import AngleBracketDownIcon from '@/assets/icon/ic_angle_bracket_down.svg';
import { SccTouchableOpacity } from '@/components/SccTouchableOpacity';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { RECOMMEND_MOBILITY_TOOL_LABELS } from '@/constant/review';
import PlaceDetailPlaceReviewItem from '@/screens/PlaceDetailScreen/components/PlaceReviewItem';
import PlaceVisitReviewFilterModal from '../modals/PlaceVisitReviewFilterModal';
const MOBILITY_LABEL_MAP = Object.assign({}, RECOMMEND_MOBILITY_TOOL_LABELS);
export default function PlaceVisitReviewInfo({ reviews, placeId }) {
    const [selectedMobilityType, setSelectedMobilityType] = useState(null);
    const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
    const filteredReviews = selectedMobilityType
        ? reviews.filter(r => { var _a; return (_a = r.recommendedMobilityTypes) === null || _a === void 0 ? void 0 : _a.includes(selectedMobilityType); })
        : reviews;
    const filterChipLabel = selectedMobilityType
        ? MOBILITY_LABEL_MAP[selectedMobilityType]
        : '모든 이동 유형';
    return (_jsxs(_Fragment, { children: [_jsxs(ChipList, { children: [_jsx(ChipContainer, { isActive: false, children: _jsx(ChipText, { isActive: false, children: "\uCD5C\uC2E0\uC21C" }) }), _jsx(SccTouchableOpacity, { elementName: "place_visit_review_filter_chip", logParams: { chipText: filterChipLabel }, activeOpacity: 0.7, onPress: () => setIsFilterModalVisible(true), children: _jsxs(FilterChipInner, { isActive: selectedMobilityType !== null, children: [_jsx(ChipText, { isActive: selectedMobilityType !== null, children: filterChipLabel }), _jsx(AngleBracketDownIcon, { width: 16, height: 16, color: selectedMobilityType !== null ? color.brand50 : color.gray100 })] }) })] }), _jsx(ItemList, { children: filteredReviews.map((review, idx) => (_jsxs(React.Fragment, { children: [_jsx(PlaceDetailPlaceReviewItem, { placeId: placeId, review: review }), idx !== filteredReviews.length - 1 && _jsx(Divider, {})] }, review.id))) }), _jsx(PlaceVisitReviewFilterModal, { isVisible: isFilterModalVisible, selected: selectedMobilityType, onSelect: setSelectedMobilityType, onClose: () => setIsFilterModalVisible(false) })] }));
}
const ChipList = styled.View `
  flex-direction: row;
  gap: 8px;
`;
const ChipContainer = styled.View `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({ isActive }) => (isActive ? color.brand5 : color.white)};
  padding-vertical: 6px;
  padding-horizontal: 12px;
  border-radius: 56px;
  gap: 3px;
  border-width: 1px;
  border-color: ${({ isActive }) => (isActive ? color.brand : color.gray20)};
`;
const FilterChipInner = styled.View `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({ isActive }) => (isActive ? color.brand5 : color.white)};
  padding-vertical: 6px;
  padding-horizontal: 12px;
  border-radius: 56px;
  gap: 3px;
  border-width: 1px;
  border-color: ${({ isActive }) => (isActive ? color.brand : color.gray20)};
`;
const ChipText = styled.Text `
  font-size: 13px;
  font-family: ${() => font.pretendardMedium};
  color: ${({ isActive }) => (isActive ? color.brand50 : color.gray100)};
`;
const ItemList = styled.View `
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const Divider = styled.View `
  height: 1px;
  background-color: ${color.gray20};
`;
